<script>

  export default {
    props: {
      fields: {
        type: Object,
        default: () => {},
        required: true
      }
    },
    data () {
      return {
        imageSettings: '?w=480&h=320&fm=jpg&fit=fill&fl=progressive&q=80'
      }
    },
    computed: {
      contentType () {
        if (this.fields.content && this.fields.content.sys.contentType) {
          return this.fields.content.sys.contentType.sys.id
        }
        return 'custom'
      },
      title () {
        if (this.fields.cardTitle) return this.fields.cardTitle
        if (this.fields.content) {
          return this.fields.content.fields.title
        }
        return ''
      },
      text () {
        if (this.fields.contentText) return this.fields.contentText
        return ''
      },
      link () {
        if (this.contentType === 'custom' || this.fields.cardLink) {
          return this.fields.cardLink
        }
        if (this.fields.content) {
          const slug = this.fields.content.fields.slug
          const parentPage = this.fields.content.fields && this.fields.content.fields.parentPage && this.fields.content.fields.parentPage.fields
          const grandParentPage = parentPage && parentPage.parentPage && parentPage.parentPage.fields
          let prefix = '/'
          if (this.contentType === 'article') prefix += 'artikel/'
          if (grandParentPage) {
            prefix += grandParentPage.slug + '/'
          }
          if (parentPage) {
            prefix += parentPage.slug + '/'
          }
          return prefix + slug
        }
        return ''
      },
      image () {
        if (this.fields.cardImage) {
          return 'https:' + this.fields.cardImage.fields.file.url + this.imageSettings
        }
        if (this.fields.content && this.fields.content.fields && this.fields.content.fields.featuredImage) {
          return 'https:' + this.fields.content.fields.featuredImage.fields.file.url + this.imageSettings
        }
        return ''
      },
      alt () {
        if (!this.image) return ''
        if (!this.fields.cardImage) return ''
        return this.fields.cardImage.fields.description
      }
    }
  }
</script>

<template>
  <div
    class="link-block"
    :style="{ backgroundImage: `url('${image}')` }"
  >
    <nuxt-link :to="fields.cardLink">
      <div class="block-content">
        <h2
          v-if="title"
          class="title"
        >
          {{ title }}
          <q-icon
            name="chevron-right"
            class="text-blue"
          />
        </h2>
        <p
          v-if="fields.cardText"
          class="mb-0 text-base text-gray-500"
        >
          {{ fields.cardText }}
        </p>
      </div>
    </nuxt-link>
  </div>
</template>

<style lang="css" scoped>

.link-block {
  min-height: 200px;
  height: 100%;
  @apply relative overflow-hidden rounded-lg bg-cover bg-center;

  @media screen and (min-width: 1440px) {
    min-height: 280px;
  }
}
.block-content {
  @apply bg-white absolute bottom-4 right-4 left-4 rounded-lg p-4 lg:bottom-7 lg:right-7 lg:left-7;
}
.title {
  @apply mb-0 font-semibold text-1xl flex justify-between;

  svg {
    @apply text-blue-500;
  }
}
</style>
